import React from 'react';
import EditFilledIcon from '@atlaskit/icon/glyph/edit-filled';

import { useIntl } from '@atlassian/jira-intl';

import { useRouterActions } from '@atlassian/jira-router';

import messages from '../../common/messages';

export const useManageIssueTypeOption = (manageIssueTypesLink: string | null) => {
	const { push } = useRouterActions();
	const { formatMessage } = useIntl();

	return manageIssueTypesLink
		? [
				{
					label: formatMessage(messages.manageIssueTypes),
					value: manageIssueTypesLink,
					icon: <EditFilledIcon size="small" label={formatMessage(messages.manageIssueTypes)} />,
					onItemSelect: () => {
						push(manageIssueTypesLink);
					},
					optionType: 'link' as const,
				},
			]
		: null;
};
